import React from 'react';

const CityContext = React.createContext({});

export default CityContext;
